import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { getPendingOrderKind, isPendingLimitTabKind } from '@flipster/features/src/shared/position/pending-order-roles';
import { accountBunja } from '@flipster/r230522/original/account';
import type { PendingPosition } from '@flipster/r230522/original/order';

import LimitOrderRow from './limit-order-row';
import TriggerOrderRow from './trigger-order-row';

interface Props {
  item: PendingPosition;
  index: number;
}

// Limit 탭 행(`limit` / `limitTpsl`)만 LimitOrderRow로 간다. 미발동 Trigger 주문
// (`triggerLimit` / `triggerMarket`)은 TriggerOrderRow로 떨어져 Trigger 탭 열 구성에 맞춰 그려진다.
const PendingPositionRow = ({ item, index }: Props) => {
  const { v2AccountAtom } = useBunja(accountBunja);
  const account = useAtomValue(v2AccountAtom);
  const isOneWayMode = account?.tradeMode === 'OneWay';

  if (isPendingLimitTabKind(getPendingOrderKind(item))) {
    return <LimitOrderRow item={item} index={index} isOneWayMode={isOneWayMode} />;
  }
  return <TriggerOrderRow item={item} index={index} isOneWayMode={isOneWayMode} />;
};

export default PendingPositionRow;
